// extracted by mini-css-extract-plugin
export default {"content":"Login_content__JjaqU"};